import { Component, Input, OnInit } from '@angular/core';
import { CaseService } from '../../services/case.service';
import { LookupService } from '../../services/lookup.service';
import { ProcessEnum, SharedHttpService } from '../../services/shared-http.service';
import { Role } from '../../services/role.service';

import { DateFormatterService } from '../date-picker/date-formatter.service';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-account-statment',
  templateUrl: './account-statment.component.html',
  styleUrls: ['./account-statment.component.scss']
})
export class AccountStatmentComponent implements OnInit {
  public loadfromparent = new BehaviorSubject<any>('');
  public loadfromparent2 = new BehaviorSubject<any>('');
  public loadfromparent3 = new BehaviorSubject<any>('');
  public loadfromparent4 = new BehaviorSubject<any>('');


  @Input() eCaseId: any;
  accountStatementId: any;
  caseId: any;
  identityTypesArr: any = [];
  identityTypeId: any;
  identityForInquery: string = '';
  startDate: any;
  endDate: any;
  draftingRequest: any;
  evidences: any;
  AttachShow: boolean = false;
  accountStatmentArr: any = [];
  isValidIdentityNumber: any = true;
  // isValidIqamaNumber:any = true;
  editedAccountStatment: any;
  editedStartDate: any;
  editedEndDate: any;
  caseDetails: any;
  branchProsecutionArr: any = [];
  prosecuationId: any;
  today = new Date();
  currentDate: NgbDateStruct;
  currentDateHijri: NgbDateStruct;

  startDateHijri: NgbDateStruct;
  startDateGreg: NgbDateStruct;

  endDateHijri: NgbDateStruct;
  endDateGreg: NgbDateStruct;
  firstName: any;
  secondName: any;
  thirdName: any;
  fourthName: any;
  nationalityArr: any = [];
  nationalityId: any;
  accountStatmentRequestCategoriesArr: any = [];
  accountStatmentRequestCategoriesId: any;
  events: any;
  public Process = ProcessEnum;
  public RoleEnum = Role
  addAccountStatmentShow: boolean = false;


  constructor(private dateformat: DateFormatterService, private caseService: CaseService, public sharedService: SharedHttpService, private lookupService: LookupService, private modalService: NgbModal,) { }


  ngOnInit(): void {
    this.loadData();
    this.caseId = this.caseService.case.caseId;
    this.caseDetails = this.caseService.case;
    this.identityTypesArr = this.lookupService.getLockup('identitytypes');
    this.nationalityArr = this.lookupService.getLockup('nationalities');
    this.accountStatmentRequestCategoriesArr = this.lookupService.getLockup('accountstatmentrequestcategories');

    this.currentDate = this.sharedService.convertDateToNgbDateStruct(this.today);
    this.endDateGreg = this.currentDate;
    this.currentDateHijri = this.dateformat.ToHijri(this.currentDate);
    this.endDateHijri = this.currentDateHijri;
  }
  loadData() {
    this.sharedService.get(`api/AccountStatement/GetAccountStatements?eCaseId=${this.eCaseId}`).subscribe(res => {
      this.accountStatmentArr = res;
    })
  }
  accountStatmentAttachment(id, model) {
    this.sharedService.openLarge(model);
    this.loadfromparent.next({ "id": id, "IsReadOnly": false });
  }
  selectIdentityType() {
    this.identityForInquery = '';
    if (this.editedAccountStatment) {
      this.editedAccountStatment.identityForInquery = '';
    }
    this.isValidIdentityNumber = true;
    // this.isValidIqamaNumber = true
  }
  SelectedFromDateChange(event) {
    this.startDate = this.dateformat.ToGregorian2(event);
    this.startDateGreg = this.dateformat.ToGregorian(event);
    this.startDateHijri = this.dateformat.ToHijri(event);
  }
  SelectedEndDateChange(event) {
    this.endDate = this.dateformat.ToGregorian2(event);
    this.endDateGreg = this.dateformat.ToGregorian(event);
    this.endDateHijri = this.dateformat.ToHijri(event);
  }
  SelectedFromDateEditChange(event) {
    this.editedAccountStatment.startDate = this.dateformat.ToGregorian2(event);
    this.startDateGreg = this.dateformat.ToGregorian(event);
    this.startDateHijri = this.dateformat.ToHijri(event);
  }
  SelectedEndDateEditChange(event) {
    this.editedAccountStatment.endDate = this.dateformat.ToGregorian2(event);
    this.endDateGreg = this.dateformat.ToGregorian(event);
    this.endDateHijri = this.dateformat.ToHijri(event);
  }
  numberOnly(event, isIdentityNumberOrIqamaNumber) {
    var inp = String.fromCharCode(event.keyCode);
    let pattern = /^\d+$/;
    if (isIdentityNumberOrIqamaNumber) {
      // this.isValidIdentityNumber=true;
      // this.isValidIqamaNumber=true;
      if (this.editedAccountStatment) {
        this.isValidIdentityNumber = this.sharedService.isValidSaudiID(this.editedAccountStatment.identityForInquery);

        // if(this.editedAccountStatment.identityTypeId==1 && !this.editedAccountStatment.identityForInquery.startsWith('1') ){
        //   this.isValidIdentityNumber=false;
        // }else{
        //   this.isValidIdentityNumber=true;
        // }
        // if(this.editedAccountStatment.identityTypeId==2 && !this.editedAccountStatment.identityForInquery.startsWith('2') ){
        //   this.isValidIqamaNumber=false;
        // }else{
        //   this.isValidIqamaNumber=true;
        // }
      } else {
        this.isValidIdentityNumber = this.sharedService.isValidSaudiID(this.identityForInquery);

        // if(this.identityTypeId==1 && !this.identityForInquery.startsWith('1') ){
        //   this.isValidIdentityNumber=false;
        // }else{
        //   this.isValidIdentityNumber=true;
        // }
        // if(this.identityTypeId==2 && !this.identityForInquery.startsWith('2') ){
        //   this.isValidIqamaNumber=false;
        // }else{
        //   this.isValidIqamaNumber=true;
        // }
      }
    }

    if (pattern.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  openCreateModal(modal) {
    this.addAccountStatmentShow = true;
    this.sharedService.get(`api/Branch/GetBranchProsecutionLookup?BranchId=${this.caseDetails.branchId}`).subscribe(res => {
      this.branchProsecutionArr = res;

      this.identityTypeId = undefined;
      this.accountStatementId = undefined;
      this.prosecuationId = undefined;
      this.AttachShow = false;
      this.identityForInquery = undefined;
      this.startDate = undefined;
      this.endDate = undefined;
      this.draftingRequest = undefined;
      this.evidences = undefined;
      this.startDateGreg = undefined;
      this.startDateHijri = undefined;
      this.endDateGreg = undefined;
      this.endDateHijri = undefined;
      this.firstName = undefined;
      this.secondName = undefined;
      this.thirdName = undefined;
      this.fourthName = undefined;
      this.nationalityId = undefined;
      this.events = undefined;
      this.accountStatmentRequestCategoriesId = undefined;
    });
  }
  addAccountStatment() {
    let obj = {
      "accountStatementId": this.accountStatementId,
      "caseId": this.caseId,
      "identityTypeId": this.identityTypeId,
      "identityForInquery": this.identityForInquery,
      "startDate": this.startDate,
      "endDate": this.endDate,
      "draftingRequest": this.draftingRequest,
      "evidences": this.evidences,
      "prosecutionId": this.prosecuationId,
      "firstName": this.firstName,
      "secondName": this.secondName,
      "thirdName": this.thirdName,
      "fourName": this.fourthName,
      "nationalityId": this.nationalityId,
      "isDeleted": false,
      "catRequest": this.accountStatmentRequestCategoriesId,
      "events": this.events
    };
    if (this.accountStatementId) {
      this.sharedService.put(`api/AccountStatement/Update`, [obj]).subscribe(res => {

        this.loadData();
        this.sharedService.showSuccessKey("AccountStatmentEditedSuccessfully");
      });
    } else {
      this.sharedService.post(`api/AccountStatement/Insert`, [obj]).subscribe(res => {
        this.AttachShow = true;
        this.accountStatementId = res[0].accountStatementId;
        this.sharedService.showSuccessKey("AccountStatmentAddedSuccessfully");
        this.loadData();
        this.loadfromparent2.next({ "id": res[0].accountStatementId, "IsReadOnly": false });

      });

    }
  }

  addAccountStatmentAndBack() {
    let obj = {
      "accountStatementId": this.accountStatementId,
      "caseId": this.caseId,
      "identityTypeId": this.identityTypeId,
      "identityForInquery": this.identityForInquery,
      "startDate": this.startDate,
      "endDate": this.endDate,
      "draftingRequest": this.draftingRequest,
      "evidences": this.evidences,
      "prosecutionId": this.prosecuationId,
      "firstName": this.firstName,
      "secondName": this.secondName,
      "thirdName": this.thirdName,
      "fourName": this.fourthName,
      "nationalityId": this.nationalityId,
      "isDeleted": false,
      "catRequest": this.accountStatmentRequestCategoriesId,
      "events": this.events
    };

    this.sharedService.post(`api/AccountStatement/Insert`, [obj]).subscribe(res => {

      this.sharedService.showSuccessKey("AccountStatmentAddedSuccessfully");
      this.addAccountStatmentShow = false;
      this.loadData();

    });


  }
  deleteAccountStatment(accountStatmentId: any, mymodal) {
    this.sharedService.openSmall(mymodal);
    this.accountStatementId = accountStatmentId;
  }
  onDeleteAccountStatment(modal) {
    this.sharedService.delete(`api/AccountStatement/Delete`, [this.accountStatementId]).subscribe((response) => {
      this.loadData();
      this.accountStatementId = undefined;
      modal.dismiss('Cross click');
      this.sharedService.showSuccessKey("AccountStatmentDeletedSuccessfully");
    },

    );
  }
  accountStatmentPreview(accountStatment, modal) {
    this.editedAccountStatment = {};
    this.editedAccountStatment = { ...accountStatment };
    this.loadfromparent4.next({ "id": this.editedAccountStatment.accountStatementId, "IsReadOnly": true });
    this.sharedService.openLarge(modal);
  }
  editAccountStatment(accountStatment, modal) {
    this.editedAccountStatment = {};
    this.editedAccountStatment = { ...accountStatment };
    this.loadfromparent3.next({ "id": accountStatment.accountStatementId, "IsReadOnly": false });
    this.editedStartDate = this.sharedService.convertDateToNgbDateStruct(accountStatment.startDate);
    this.startDateGreg = this.dateformat.ToGregorian(this.editedStartDate);
    this.startDateHijri = this.dateformat.ToGregorian(this.editedStartDate);
    this.editedEndDate = this.sharedService.convertDateToNgbDateStruct(accountStatment.endDate);
    this.endDateGreg = this.dateformat.ToGregorian(this.editedEndDate);
    this.endDateHijri = this.dateformat.ToGregorian(this.editedEndDate);
    this.sharedService.openLarge(modal);
  }
  onEditAccountStatment(modal) {
    let obj = {
      "accountStatementId": this.editedAccountStatment.accountStatementId,
      "caseId": this.caseId,
      "identityTypeId": this.editedAccountStatment.identityTypeId,
      "identityForInquery": this.editedAccountStatment.identityForInquery,
      "startDate": this.editedAccountStatment.startDate,
      "endDate": this.editedAccountStatment.endDate,
      "draftingRequest": this.editedAccountStatment.draftingRequest,
      "evidences": this.editedAccountStatment.evidences,
      "firstName": this.editedAccountStatment.firstName,
      "secondName": this.editedAccountStatment.secondName,
      "thirdName": this.editedAccountStatment.thirdName,
      "fourName": this.editedAccountStatment.fourName,
      "nationalityId": this.editedAccountStatment.nationalityId,
      "isDeleted": false,
      "catRequest": this.editedAccountStatment.catRequest,
      "events": this.editedAccountStatment.events
    };
    this.sharedService.put(`api/AccountStatement/Update`, [obj]).subscribe(res => {
      modal.dismiss('Cross click');
      this.loadData();
      this.sharedService.showSuccessKey("AccountStatmentEditedSuccessfully");
    });
  }
  open(modal) {
    this.sharedService.openSmall(modal);
  }
  isAcceptFun(isAccept: boolean) {
    let obj = {
      "accountStatementId": this.editedAccountStatment.accountStatementId,
      "caseId": this.editedAccountStatment.caseId,
      "isAccepted": isAccept,
      "isDeleted": false,
      "rejectReason": this.editedAccountStatment.rejectReason
    }
    this.sharedService.post(`api/AccountStatement/AcceptReject`, obj).subscribe(res => {
      this.loadData();

      res && isAccept ? this.sharedService.showSuccessKey('SentToTheProsecution') :

        (res && !isAccept) ? this.sharedService.showSuccessKey('RequestHasBeenRejected') :
          this.sharedService.showErrorKey('SomethingWentWrong')
        ;
      this.modalService.dismissAll();
    }, err => {
      this.modalService.dismissAll();
      this.sharedService.showErrorKey('SomethingWentWrong')
    })
  }


}
